import { useQuery } from '@tanstack/react-query'
import { fetchActionsPage } from '~/domains/actions/queries/actions'
import { toTaskActionsParams } from './tasks'

const endOfToday = (now: Date) => {
  const end = new Date(now)
  end.setHours(23, 59, 59, 999)
  return end
}

const fetchTasksCount = async (userId: number, before: Date) => {
  const page = await fetchActionsPage(
    toTaskActionsParams({
      user: userId,
      itemsPerPage: 1,
      isCompleted: false,
      scheduledDate: { before: before.toISOString() }
    })
  )
  return page['hydra:totalItems'] ?? 0
}

export const useTasksCount = (userId: number | null) => {
  const overdueQuery = useQuery({
    queryKey: ['tasks', 'count', 'overdue', userId],
    queryFn: () => fetchTasksCount(userId ?? 0, new Date()),
    enabled: userId !== null,
    staleTime: 60_000,
    refetchOnWindowFocus: true
  })
  const todayQuery = useQuery({
    queryKey: ['tasks', 'count', 'today', userId],
    queryFn: () => fetchTasksCount(userId ?? 0, endOfToday(new Date())),
    enabled: userId !== null,
    staleTime: 60_000,
    refetchOnWindowFocus: true
  })

  const overdue = overdueQuery.data ?? 0
  const dueToday = Math.max((todayQuery.data ?? 0) - overdue, 0)

  return {
    overdue,
    dueToday,
    total: overdue + dueToday,
    isLoading: overdueQuery.isLoading || todayQuery.isLoading
  }
}
